<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6vrVKp/tc-custom/9781466896376.jpg?1732161401288" alt="This image is the cover for the book Neutral Corner"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Neutral Corner
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Neutral Corner</i> collects fifteen previously unpublished boxing pieces written by legendary sportswriter A.J. Liebling between 1952 and 1963.<br/></b><br/>Demonstrating A.J. Liebling's abiding passion for the "sweet science" of boxing, <i>A Neutral Corner</i> brings together previously unpublished material. Antic, clear-eyed, and wildly entertaining, these essays showcase a<i> The New Yorker</i> journalist at the top of his form. Here one relives the high drama of the classic Patterson-Johansson championship bout of 1959, and Liebling's early prescient portrayal of Cassius Clay's style as a boxer and a poet is not to be missed.<br/><br/>Liebling always finds the human story that makes these essays appealing to aficionados of boxing and prose alike. Alive with a true fan's reverence for the sport, yet balanced by a true skeptic's disdain for sentiment, <i>A Neutral Corner </i>is an American treasure.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A. J. Liebling, Fred Warner, James Harbour
      </h2>
      
      <p class="authorDescription body article"><P><B>A.J. Liebling </B>joined the staff of <I>The New Yorker</I> in 1935 and wrote for the magazine until his death in 1963. His books include <I>Between Meals, A Neutral Corner</I>, and <I>The Honest Rainmaker.</I><br><B><br>Fred Warner</B> and <B>James Barbour</B> are emeritus professors at the University of New Mexico.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7bff7159